export default (size: number) => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return Number((size / Math.pow(1024, i)).toFixed(1)) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

export const getExtension = (attachment: { extension: string; name: string }) => {
  if (!attachment) return '';

  return attachment.extension
    || attachment.name.split('.').pop()
    || 'text';
}
